import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

export const DatabaseEntryPickerOptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${token('space.100', '8px')};
`;
